import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Api } from 'src/app/enums/network/api';

@Injectable({
  providedIn: 'root',
})
export class NetworkManager {
  constructor(private _http: HttpClient) {}

  http() {
    return this._http;
  }

  public CodaQApi() {
    switch (environment.mode) {
      case 'PROD':
        return Api.CODAQ_API_PROD;
      case 'DEV':
        return Api.CODAQ_API_DEV;
    }
  }

  public MediaApi() {
    switch (environment.mode) {
      case 'PROD':
        return Api.MEDIA_API_PROD;
      case 'DEV':
        return Api.MEDIA_API_DEV;
    }
  }

  public ExtraParamsApi() {
    switch (environment.mode) {
      case 'PROD':
        return Api.EXTRA_PARAMS_API_PROD;
      case 'DEV':
        return Api.EXTRA_PARAMS_API_DEV;
    }
  }

  public StatsApi() {
    switch (environment.mode) {
      case 'PROD':
        return Api.STATS_API_PROD;
      case 'DEV':
        return Api.STATS_API_DEV;
    }
  }

  public AuthApi() {
    switch (environment.mode) {
      case 'PROD':
        return Api.AUTH_API_PROD;
      case 'DEV':
        return Api.AUTH_API_DEV;
    }
  }
}
